<app-toolbar></app-toolbar>
<div class="main-layout content">
  <div class="card-container">
    <div class="card">
      <img
        [src]="
          result == 'lose'
            ? '../../../../../assets/lose.svg'
            : '../../../../../assets/win.svg'
        "
        alt="gears"
        width="10%"
      />
      <h1 class="title-card">
        {{ screenMessage.result }}
      </h1>
      <h1 class="title-card">
        {{ screenMessage.title }}
      </h1>
      <h1 class="title-card">
        {{ screenMessage.subtitle }}
      </h1>
      <br />

      <div>
        <button class="btn start-over" (click)="startOver()">Start Over</button>

        <button class="btn return" (click)="returnToHome()">
          Back to home
        </button>
      </div>
    </div>
  </div>

  <!-- Bottom Side -->
  <div class="adoption-stage-box">
    <app-adoption-stage [value]="adoptionStageValue"></app-adoption-stage>

    <app-credibility [credibility]="credibility"></app-credibility>

    <app-useful-weeks [weeksProgress]="usefulWeeksValue"></app-useful-weeks>

    <app-critical-mass [criticalMass]="criticalMass"></app-critical-mass>
  </div>
</div>
